require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/react-phone-number-input/~/babel-runtime/~/core-js/library/modules/es7.symbol.observable.js
// module id = ./node_modules/react-phone-number-input/node_modules/babel-runtime/node_modules/core-js/library/modules/es7.symbol.observable.js
// module chunks = 0 1 2